{
  "nav": {
    "primary": "Main",
    "login": "Log in",
    "getStarted": "Get started"
  },
  "home": {
    "title": "Planetra — geospatial intelligence for Malaysian town planners",
    "description": "Classify satellite imagery, compare it against Guna Tanah, and produce planning evidence that stands up to scrutiny.",
    "tagline": "Satellite imagery, land-use analysis and planning simulation in one workspace.",
    "capabilities": {
      "imagery": {
        "title": "Imagery",
        "body": "Order and classify satellite scenes over any area of interest."
      },
      "analysis": {
        "title": "Analysis",
        "body": "Compare observed land cover against gazetted Guna Tanah and surface every discrepancy."
      },
      "simulation": {
        "title": "Simulation",
        "body": "Model proposed development and see its effect before it is approved."
      }
    }
  },
  "footer": {
    "rights": "© Planetra. Built for Malaysian town planners."
  }
}
